import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LiveRefreshService } from '@/services/live-refresh.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent {
    // با انتشار نسخه‌ی جدید، صفحه خودکار تازه می‌شود
    constructor() {
        inject(LiveRefreshService).startVersionCheck();
    }
}
